import React from 'react'
import { formatUnitsForReport } from '../../../../helpers/units';
import calculatePrice from '../../../../helpers/calculate_price';

export const columnsExternal = (props, setOpenBucketModal, populateCartFromDraft,
  setToGeneratePo, setToDispatch, setSelectedOrder, openDetails, groupBy, setRemarksModal, remarksModal,
  setIsDispatched, loadMappedItems) => {
    return [

      {
        dataField: "_id",
        hidden: true,
      },
      {
        dataField: "_id",
        formatter: (cell, row, rowIndex) => {
          return rowIndex + 1;
        },
        text: props.t("#"),
        headerStyle: (colum, colIndex) => {
          return { width: "5%" };
        },
      },
      {
        dataField: "order_id",
        text: props.t("Order ID"),
        formatter: openDetails,
        headerStyle: (colum, colIndex) => {
          return { width: "18%" };
        },
        style: { cursor: "pointer" },
      },
      {
        dataField: "branch_details.name",
        text: props.t("Store Name"),
        headerStyle: (colum, colIndex) => {
          return { width: "12%" };
        },
        style: { cursor: "pointer" },
      },
      {
        dataField: "remarks",
        text: props.t("Remarks"),
        headerStyle: (colum, colIndex) => {
          return { width: "20%" };
        },
        style: { cursor: "pointer" },
      },
      {
        text: props.t("Order Date"),
        headerStyle: (colum, colIndex) => {
          return { width: "14%" };
        },
        dataField: "createdAt",
        style: { cursor: "pointer" },
      },
      {
        text: props.t("Is Urgent?"),
        headerStyle: (colum, colIndex) => {
          return { width: "8%" };
        },
        formatter: (cell, row) => {
          if (row.is_urgent) {
            return props.t("Yes");
          } else {
            return props.t("No");
          }
        },
        style: { cursor: "pointer" },
      },
      {
        dataField: "status",
        text: props.t("Status"),
        headerStyle: (colum, colIndex) => {
          return { width: "12%" };
        },
        style: { cursor: "pointer" },
      },
      {
        dataField: "",
        text: props.t("Action"),
        sort: false,
        formatter: (cell, row) => {
          let isDisabled = (row.status === "Partially Received" ||row.status === "Received") 
          return (
            <>
              <button
                class="btn btn-info btn-sm mr-2"
                style={{
                  cursor: isDisabled ? 'not-allowed' : 'pointer',
                }}
                disabled={isDisabled}
                onClick={async () => {
                  setSelectedOrder(row);
                  loadMappedItems(row.branch_details);
                  if (row.status === "Approved" || row.status === "Dispatched" || row.status === "Partially Received" || row.status === "PO is pending") {
                    const updatedDPItems = row.dispatch_bucket.map(
                      (item, ind) => {
                        return {
                          ...item,
                          uniqueId: `${Date.now()}-${ind + 1}`,
                          quantity: row.dispatch_bucket_status === "Dispatched" ? item.delivered_quantity : item.dispatch_quantity,
                        };
                      }
                    );
                    setToDispatch(updatedDPItems);
                    // console.log(0);
                    if (row.po_bucket_status === "Pending" && (row.status === "Approved" || row.status === "Dispatched") && row.dispatch_bucket_status !== "Dispatched") {
                      const updatedPOItems = row.po_bucket.map((item, index) => {
                        const calculatedPrice = calculatePrice(
                          item.unit_levels,
                          item.po_quantity,
                          item.po_price,
                          item.unit_for_po
                        );
                        return {
                          ...item,
                          quantity: item.po_quantity,
                          uniqueId: `${Date.now()}-${index + 2}`,
                          total_price: calculatedPrice,
                        };
                      });
                      await setToGeneratePo(() =>
                        groupBy(updatedPOItems, "category")
                      );
                    } else if (row.po_bucket_status === "Pending" && (row.status === "Dispatched" && row.dispatch_bucket_status === "Dispatched")) {
                      // console.log(2);
                      populateCartFromDraft(row.po_bucket)
                    }
                    else {
                      // console.log(3);
                      populateCartFromDraft(row.po_bucket)
                    }
                  }
                  setOpenBucketModal(true)
                }}
              >
                {props.t("Dispatch & Generate PO")}
              </button>
              <button
                class="btn btn-danger btn-sm mr-2"
                onClick={() => {
                  setRemarksModal(!remarksModal);
                  setSelectedOrder(row);
                  if (row.status === "Dispatched") setIsDispatched(false);
                }}
              >
                {props.t("Close")}
              </button>
            </>
          );
        },
        headerStyle: (colum, colIndex) => {
          return { width: "20%" };
        },
      },
    ]
}

export const dispatchColumns = (props, selectedOrder, setSelectedItem, setSelectedRowsUnit, setEditUnitModal, setEditFor, ItemsDispatched, handleDeleteRow, handleTransferItem, isTransferrable) => {

  return [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "11%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      dataField: "available",
      text: selectedOrder?.branch_details?.type === "Sub Store" ? "Store Avl." : "Branch Avl. ",
      formatter: (cell, row) => {
        return formatUnitsForReport(row.available, row.unit_levels);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Order Qty."),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          const is_newly_added = row.is_new_item_added
          const updatedItem = {
            ...row,
            quantity: row.quantity.map((item, idx) => ({
              ...item,
              index: idx,
              isChecked: true,
            })),
          };
          setSelectedItem(updatedItem);
          setSelectedRowsUnit(updatedItem.quantity);
          if (!ItemsDispatched && !is_newly_added) {
           setEditUnitModal(true);
           setEditFor("for_dispatch");
          }
        },
      },
      style: (cell, row, rowIndex, colIndex) => {
        const is_newly_added = row.is_new_item_added
        return { cursor: "pointer", background: `${(ItemsDispatched || is_newly_added) ? null : "#ffffaa"}` };
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "central_available",
      text: props.t("Central Avl. Qty."),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.central_available, row.unit_levels);
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "",
      text: props.t("Action"),
      sort: false,
      hidden: ItemsDispatched,
      editable: false,
      formatter: (cell, row) => {
        const is_newly_added = row.is_new_item_added
        return (
          <>
            {!is_newly_added ? (
              <span className="d-flex justify-content-between">
                <i
                  className="bx bxs-trash font-size-20 mt-1 text-danger"
                  title="Click to Remove"
                  hidden={ItemsDispatched}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setSelectedItem(row)
                    handleDeleteRow(row, "Dispatch")
                  }}
                ></i>

                <i
                  style={{ fontSize: "25px", cursor: "pointer", color: "#" }}
                  className="mdi mdi-swap-horizontal-variant info"
                  hidden={isTransferrable}
                  onClick={() => handleTransferItem(row, "to_po")}
                  disabled={isTransferrable}
                // disabled={(selectedOrder?.po_bucket_status==="PO Saved" || selectedOrder?.dispatch_bucket_status === "Dispatched")}
                />
              </span>
            ):(
              <span className="d-flex justify-content-between">
              <i
                className="bx bxs-trash font-size-20 mt-1 text-danger"
                title="Click to Remove"
                hidden={ItemsDispatched}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setSelectedItem(row)
                  handleDeleteRow(row, "Dispatch")
                }}
              ></i>
            </span>
            )}
          </>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
  ];
}

export const expandColumns = (props) => {
  return [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "order_to",
      text: props.t("Order To"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "11%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      dataField: "available",
      text: props.t("Available"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.available, row.unit_levels);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Order Qty."),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "central_available",
      text: props.t("Central Avl. Qty."),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.central_available, row.unit_levels);
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
  ];
}

export const poColumns = (props, setSelectedItem, POGenerated, setSelectedRowsUnit, setEditUnitModal, setEditFor, handleDeleteRow, handleTransferItem, isTransferrable) => {
  return [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      footer: false,
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: false,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
      footer: false,
    },
    {
      text: props.t("Order Qty."),
      dataField: "quantity",
      sort: false,
      editable: false,
      style: (cell, row, rowIndex, colIndex) => {
        return { cursor: "pointer", background: `${POGenerated ? null : "#ffffaa"}` };
      },
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          const updatedItem = {
            ...row,
            quantity: row.quantity.map((item, idx) => ({
              ...item,
              index: idx,
              isChecked: true,
            })),
          };
          setSelectedItem(updatedItem);
          setSelectedRowsUnit(updatedItem.quantity);
          if (!POGenerated) setEditUnitModal(true);
          setEditFor("for_po");
        },
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      footer: false,
    },
    {
      text: props.t("Price"),
      dataField: "po_price",
      formatter: (cell, row) => {
        return (row.po_price || 0) + " / " + row.unit_for_po;
        // return 0
      },
      sort: false,
      editable: !POGenerated,
      type:"number",
      editor: {
        type: "number", 
      },
      validator: (newValue, row, column) => {
        if (isNaN(newValue)) {
          return {
            valid: false,
            message: 'Price should be numeric'
          };
        }
        if (newValue < 0.1) {
          return {
            valid: false,
            message: 'minimum 0.1 '
          };
        }
        return true;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      footer: false,
    },
    {
      text: props.t("Total"),
      dataField: "total_price",
      sort: false,
      formatter: (cell, row) => {
        return Number(row.total_price).toFixed(2) ?? 0;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
      footer: (columnData) => {
        const total = columnData.reduce((acc, item) => acc + item, 0);
        return Number(total).toFixed(2) ?? 0;
      },
    },
    {
      dataField: "",
      text: props.t("Action"),
      sort: false,
      hidden: POGenerated,
      editable: false,
      formatter: (cell, row) => {
        return (
          <>
            <span className="d-flex justify-content-between">
              <i
                className="bx bxs-trash font-size-20 mt-1 text-danger"
                title="Click to Remove"
                hidden={POGenerated}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setSelectedItem(row)
                  handleDeleteRow(row, "PO")
                }}
              ></i>
              <i
                style={{ fontSize: "25px", cursor: "pointer", color: "#" }}
                className="mdi mdi-swap-horizontal-variant info"
                onClick={() => !isTransferrable && handleTransferItem(row, "to_dispatch")}
                hidden={isTransferrable || row.is_new_item_added}
              // disabled={(selectedOrder?.po_bucket_status==="PO Saved" || selectedOrder?.dispatch_bucket_status === "Dispatched")}
              />
            </span>
          </>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
  ];
}
